/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Val_Reason_RequiredInputs */

const vi_aml_val_reason_required = /** @type {(inputs: Aml_Val_Reason_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng chọn lý do`)
};

/**

* @param {Aml_Val_Reason_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_val_reason_required = /** @type {((inputs?: Aml_Val_Reason_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Val_Reason_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_val_reason_required(inputs)
});